import React, { useState, useRef, useEffect, useCallback } from "react";

// ─── Full regional scope data ────────────────────────────────────────────────
const GROUPS = [
  {
    group: "Global",
    items: [{ label: "Global", value: "global" }],
  },
  {
    group: "North America",
    items: [
      { label: "North America (Region)", value: "north america" },
      { label: "United States", value: "united states" },
      { label: "Canada", value: "canada" },
      { label: "Mexico", value: "mexico" },
      { label: "Rest of North America", value: "rest of north america" },
    ],
  },
  {
    group: "Europe",
    items: [
      { label: "Europe (Region)", value: "europe" },
      { label: "Germany", value: "germany" },
      { label: "France", value: "france" },
      { label: "United Kingdom", value: "united kingdom" },
      { label: "Spain", value: "spain" },
      { label: "Italy", value: "italy" },
      { label: "Russia", value: "russia" },
      { label: "Netherlands", value: "netherlands" },
      { label: "Belgium", value: "belgium" },
      { label: "Switzerland", value: "switzerland" },
      { label: "Sweden", value: "sweden" },
      { label: "Norway", value: "norway" },
      { label: "Denmark", value: "denmark" },
      { label: "Finland", value: "finland" },
      { label: "Ireland", value: "ireland" },
      { label: "Austria", value: "austria" },
      { label: "Poland", value: "poland" },
      { label: "Czech Republic", value: "czech republic" },
      { label: "Hungary", value: "hungary" },
      { label: "Romania", value: "romania" },
      { label: "Greece", value: "greece" },
      { label: "Portugal", value: "portugal" },
      { label: "Ukraine", value: "ukraine" },
      { label: "Slovakia", value: "slovakia" },
      { label: "Croatia", value: "croatia" },
      { label: "Bulgaria", value: "bulgaria" },
      { label: "Serbia", value: "serbia" },
      { label: "Lithuania", value: "lithuania" },
      { label: "Latvia", value: "latvia" },
      { label: "Estonia", value: "estonia" },
      { label: "Slovenia", value: "slovenia" },
      { label: "Luxembourg", value: "luxembourg" },
      { label: "Rest of Europe", value: "rest of europe" },
    ],
  },
  {
    group: "Asia-Pacific",
    items: [
      { label: "Asia-Pacific (Region)", value: "asia pacific" },
      { label: "China", value: "china" },
      { label: "India", value: "india" },
      { label: "Japan", value: "japan" },
      { label: "South Korea", value: "south korea" },
      { label: "Australia", value: "australia" },
      { label: "New Zealand", value: "new zealand" },
      { label: "Singapore", value: "singapore" },
      { label: "Vietnam", value: "vietnam" },
      { label: "Indonesia", value: "indonesia" },
      { label: "Malaysia", value: "malaysia" },
      { label: "Thailand", value: "thailand" },
      { label: "Philippines", value: "philippines" },
      { label: "Taiwan", value: "taiwan" },
      { label: "Hong Kong", value: "hong kong" },
      { label: "Pakistan", value: "pakistan" },
      { label: "Bangladesh", value: "bangladesh" },
      { label: "Sri Lanka", value: "sri lanka" },
      { label: "Myanmar", value: "myanmar" },
      { label: "Cambodia", value: "cambodia" },
      { label: "Kazakhstan", value: "kazakhstan" },
      { label: "Uzbekistan", value: "uzbekistan" },
      { label: "Nepal", value: "nepal" },
      { label: "Mongolia", value: "mongolia" },
      { label: "Rest of Asia-Pacific", value: "rest of asia-pacific" },
    ],
  },
  {
    group: "Latin America",
    items: [
      { label: "Latin America (Region)", value: "latin america" },
      { label: "Brazil", value: "brazil" },
      { label: "Argentina", value: "argentina" },
      { label: "Chile", value: "chile" },
      { label: "Colombia", value: "colombia" },
      { label: "Peru", value: "peru" },
      { label: "Venezuela", value: "venezuela" },
      { label: "Ecuador", value: "ecuador" },
      { label: "Bolivia", value: "bolivia" },
      { label: "Paraguay", value: "paraguay" },
      { label: "Uruguay", value: "uruguay" },
      { label: "Panama", value: "panama" },
      { label: "Costa Rica", value: "costa rica" },
      { label: "Guatemala", value: "guatemala" },
      { label: "Cuba", value: "cuba" },
      { label: "Dominican Republic", value: "dominican republic" },
      { label: "Rest of Latin America", value: "rest of latin america" },
    ],
  },
  {
    group: "Middle East and Africa",
    items: [
      { label: "Middle East and Africa (Region)", value: "middle east and africa" },
      { label: "Saudi Arabia", value: "saudi arabia" },
      { label: "UAE", value: "uae" },
      { label: "South Africa", value: "south africa" },
      { label: "Israel", value: "israel" },
      { label: "Qatar", value: "qatar" },
      { label: "Kuwait", value: "kuwait" },
      { label: "Oman", value: "oman" },
      { label: "Bahrain", value: "bahrain" },
      { label: "Iran", value: "iran" },
      { label: "Iraq", value: "iraq" },
      { label: "Turkey", value: "turkey" },
      { label: "Egypt", value: "egypt" },
      { label: "Nigeria", value: "nigeria" },
      { label: "Kenya", value: "kenya" },
      { label: "Ethiopia", value: "ethiopia" },
      { label: "Ghana", value: "ghana" },
      { label: "Morocco", value: "morocco" },
      { label: "Algeria", value: "algeria" },
      { label: "Tunisia", value: "tunisia" },
      { label: "Tanzania", value: "tanzania" },
      { label: "Uganda", value: "uganda" },
      { label: "Angola", value: "angola" },
      { label: "Ivory Coast", value: "ivory coast" },
      { label: "Cameroon", value: "cameroon" },
      { label: "Senegal", value: "senegal" },
      { label: "Jordan", value: "jordan" },
      { label: "Lebanon", value: "lebanon" },
      { label: "Libya", value: "libya" },
      { label: "Sudan", value: "sudan" },
      { label: "Zimbabwe", value: "zimbabwe" },
      { label: "Zambia", value: "zambia" },
      { label: "Rest of Middle East and Africa", value: "rest of middle east and africa" },
    ],
  },
];

const ALL_ITEMS = GROUPS.flatMap((g) =>
  g.items.map((item) => ({ ...item, group: g.group }))
);

export default function RegionalScopeSelect({ value, onChange, id }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);

  const selectedItem = ALL_ITEMS.find((i) => i.value === value) || null;
  const displayLabel = selectedItem ? selectedItem.label : "Select regional scope...";

  const q = search.trim().toLowerCase();
  const isSearching = q.length > 0;

  const filteredFlat = isSearching
    ? ALL_ITEMS.filter(
        (i) =>
          i.label.toLowerCase().includes(q) ||
          i.group.toLowerCase().includes(q)
      )
    : [];

  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (open && searchRef.current) {
      setTimeout(() => searchRef.current && searchRef.current.focus(), 50);
    }
  }, [open]);

  const handleSelect = useCallback(
    (itemValue) => {
      onChange(itemValue);
      setOpen(false);
      setSearch("");
    },
    [onChange]
  );

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setOpen(false);
      setSearch("");
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative", userSelect: "none" }} id={id}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "7px 12px",
          border: "1px solid #ced4da",
          borderRadius: 6,
          background: "#fff",
          cursor: "pointer",
          fontSize: 14,
          color: selectedItem ? "#212529" : "#6c757d",
          gap: 8,
          boxShadow: open ? "0 0 0 0.2rem rgba(13,110,253,.15)" : "none",
          borderColor: open ? "#86b7fe" : "#ced4da",
          transition: "border-color .15s,box-shadow .15s",
          textAlign: "left",
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {displayLabel}
        </span>
        <svg
          width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
          style={{
            flexShrink: 0,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform .2s",
            color: "#6c757d",
          }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div
          onKeyDown={handleKeyDown}
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ced4da",
            borderRadius: 8,
            boxShadow: "0 8px 32px rgba(0,0,0,.12)",
            display: "flex",
            flexDirection: "column",
            maxHeight: 380,
          }}
        >
          {/* Search bar */}
          <div style={{ padding: "8px 10px", borderBottom: "1px solid #f0f0f0", flexShrink: 0 }}>
            <div style={{ position: "relative" }}>
              <svg
                width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="#aaa"
                strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                style={{ position: "absolute", left: 9, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                ref={searchRef}
                type="text"
                placeholder="Search region or country..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "100%",
                  padding: "5px 28px 5px 30px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 5,
                  fontSize: 13,
                  outline: "none",
                  background: "#f9fafb",
                }}
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  style={{
                    position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
                    background: "none", border: "none", cursor: "pointer",
                    color: "#9ca3af", padding: 0, fontSize: 16, lineHeight: 1,
                  }}
                >
                  x
                </button>
              )}
            </div>
          </div>

          {/* Options */}
          <div style={{ overflowY: "auto", flex: 1 }}>
            {isSearching ? (
              filteredFlat.length === 0 ? (
                <div style={{ padding: "14px", color: "#9ca3af", fontSize: 13, textAlign: "center" }}>
                  No results for "{search}"
                </div>
              ) : (
                filteredFlat.map((item) => (
                  <OptionRow key={item.value} item={item} active={value === item.value} onSelect={handleSelect} showGroup />
                ))
              )
            ) : (
              GROUPS.map((group) => (
                <div key={group.group}>
                  <div
                    style={{
                      padding: "6px 12px 4px",
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      color: "#6366f1",
                      background: "#f5f5ff",
                      borderTop: "1px solid #ede9fe",
                      borderBottom: "1px solid #ede9fe",
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    {group.group}
                  </div>
                  {group.items.map((item) => (
                    <OptionRow key={item.value} item={item} active={value === item.value} onSelect={handleSelect} />
                  ))}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function OptionRow({ item, active, onSelect, showGroup }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      role="option"
      aria-selected={active}
      onClick={() => onSelect(item.value)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "7px 14px",
        fontSize: 13,
        cursor: "pointer",
        background: active ? "#ede9fe" : hovered ? "#f3f4f6" : "transparent",
        color: active ? "#4f46e5" : "#212529",
        fontWeight: active ? 600 : 400,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
      }}
    >
      <span>{item.label}</span>
      <span style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
        {showGroup && (
          <span style={{
            fontSize: 10, background: "#e0e7ff", color: "#4f46e5",
            borderRadius: 4, padding: "1px 6px", fontWeight: 600, letterSpacing: "0.04em",
          }}>
            {item.group}
          </span>
        )}
        {active && (
          <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="#4f46e5" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </span>
    </div>
  );
}
